import React from "react";
import { motion } from "framer-motion";
import "./FleetBanner.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function FleetBanner({
  imageUrl= "./Images/picture_fleet_banner.jpg",
  alt = "Airplane",
  
}) {
   const { t, i18n } = useTranslation("fleet"); // <-- récupérer i18n
  return (
    <motion.section
      className="fleet-banner-section"
      aria-label="Discover our fleet"
      initial={{ opacity: 0, x: -150 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}
    >
      {/* Image Strip */}
      <div className="fleet-banner-hero">
        <img src={imageUrl} alt={alt} className="fleet-banner-img" />
        <div className="fleet-banner-overlay" />
          <div className="fleet-banner-text">
    <h2>{t("title")}</h2>
    <p>
      {t("title2")}
    </p>
  </div>
      </div>

      {/* CTA Button */}
<div className="fleet-banner-cta">
  <Link to="/aircrafts" className="fleet-banner-button">
    {t("button")}
    <span aria-hidden="true" className="fleet-banner-arrow">→</span>
  </Link>
</div>

    </motion.section>
  );
}
